import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Door } from '../../../../models/configurators-2d/applications/fence/door';
import { from, Observable, tap } from 'rxjs';
import { Configuration } from '../../../../models/configurators-2d/applications/fence/configuration';
import { FenceService } from '../../../../services/configurators-2d/applications/fence.service';
import { getMaxHeight } from '../../../../services/helpers/fence-helper';

@Injectable({
  providedIn: 'root',
})
export class DoorStateService {
  /**
   * Liste des portillons disponibles
   */
  doors: WritableSignal<Door[]> = signal([]);

  /**
   * Indique si le service est entrain de faire des changements
   */
  loading: WritableSignal<boolean> = signal(false);

  private readonly fenceService = inject(FenceService);

  /**
   * Requête l'APi et défini la liste des portillons disponibles
   * @param configuration
   */
  setList(configuration: Configuration): Observable<Door[]> {
    this.loading.set(true);
    return from(
      this.fenceService.getDoors(
        configuration.postType.id,
        getMaxHeight(configuration),
        configuration.doors.map(d => d.id)
      )
    ).pipe(
      tap((res: Door[]) => {
        // Assigne la quantité aux portillons (si elle est définie dans la configuration)
        for (const door of res) {
          door.quantity = configuration.doors?.find(d => d.id === door.id)?.quantity ?? 0;
        }

        this.doors.set(res);
      })
    );
  }
}
